import { render, staticRenderFns } from "./adminServiceDepartment.vue?vue&type=template&id=c282a716&scoped=true"
import script from "./adminServiceDepartment.vue?vue&type=script&lang=js"
export * from "./adminServiceDepartment.vue?vue&type=script&lang=js"
import style0 from "./adminServiceDepartment.vue?vue&type=style&index=0&id=c282a716&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c282a716",
  null
  
)

export default component.exports